import { showToast } from "./guest-slices/other.slice"
import { checkTokenErr } from "../utils/helper"
import axios from "axios"

export const asyncThunkWrapper = async (
  axiosConfig,
  { dispatch, rejectWithValue },
  {
    successMsg = null,
    toast = true
  } = {}
) => {
  try {
    const response = await axios(axiosConfig)

    if (response.data?.success) {
      if (toast) dispatch(showToast({
        type: "success",
        message: successMsg || response?.data?.message
      }))
      return response?.data?.data || response.data
    } else {
      const newErr = response.data?.message || response.data?.error || "Something went wrong here!"
      if (toast) dispatch(showToast({
        type: "error",
        message: newErr
      }))
    }

    return response
  } catch (error) {
    checkTokenErr(error, dispatch)
    const newErr = error?.response?.data?.message || error?.response?.data?.error || "Something went wrong!"
    if (toast) {
      return dispatch(showToast({
        type: "error",
        message: newErr
      }))
    }
    rejectWithValue(error)
  }
}

const thunkHandler = async (
  axiosConfig,
  { dispatch, rejectWithValue },
  {
    errorMsg = null,
    successMsg = null,
    errorToast = true,
    successToast = true,
  } = {}
) => {
  try {
    const response = await axios(axiosConfig)

    if (response.data?.success) {
      if (successToast) dispatch(showToast({
        type: "success",
        message: successMsg || response?.data?.message
      }))
      return response.data
    } else {
      const newErr = response.data?.message || response.data?.error || "Something went wrong here!"
      if (errorToast) dispatch(showToast({
        type: "error",
        message: newErr
      }))
    }

    return response
  } catch (error) {
    checkTokenErr(error, dispatch)
    const newErr = errorMsg || error?.response?.data?.message || error?.response?.data?.error || "Something went wrong!"
    if (errorToast) {
      return dispatch(showToast({
        type: "error",
        message: newErr
      }))
    }
    rejectWithValue(error)
  }
}

export default thunkHandler